import { render, staticRenderFns } from "./RegenerateForm.vue?vue&type=template&id=7940fe10&scoped=true&"
import script from "./RegenerateForm.vue?vue&type=script&lang=js&"
export * from "./RegenerateForm.vue?vue&type=script&lang=js&"
import style0 from "./RegenerateForm.vue?vue&type=style&index=0&id=7940fe10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7940fe10",
  null
  
)

export default component.exports